import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { RecentlySearches, ResponseData } from "../common"

export interface GetRecentSearchesAPIResponseData extends ResponseData {
  data: RecentlySearches[]
}

export interface GetRecentSearchesAPIResponse extends AxiosResponse {
  data: GetRecentSearchesAPIResponseData
}

export function getRecentlySearchesApi(
  axiosInstance: AxiosInstance,
): Promise<GetRecentSearchesAPIResponse> {
  return axiosInstance({
    method: "get",
    url: `/search/recent-search`,
  }) as Promise<GetRecentSearchesAPIResponse>
}

export interface SaveRecentSearchesAPIRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    recentSearches: RecentlySearches[]
  }
}

export function saveRecentlySearchesApi(
  { params }: SaveRecentSearchesAPIRequest,
  axiosInstance: AxiosInstance,
): Promise<GetRecentSearchesAPIResponse> {
  return axiosInstance({
    data: params,
    method: "post",
    url: `/search/recent-search`,
  }) as Promise<GetRecentSearchesAPIResponse>
}
